import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { ISearch } from 'app/models/licenses/search';
import { IStaff } from 'app/models/user/staff';
import { IHospitalLicense } from 'app/models/licenses/hospital/hospital-license';
import { ILicenseRequest } from 'app/models/licenses/license-request';
import { IRepresentativeContact } from 'app/models/licenses/hospital/representative-contact';

@Injectable({providedIn: 'root'})
export class HospitalLicenseService {
  private api: string = environment.privateApi + 'HospitalLicense/';
  private changeApi: string = environment.privateApi + 'HospitalChange/';
  private dataMigrationApi: string = environment.privateApi + 'DataMigration/';

  private http = inject(HttpClient);

  public searchLicenses(search: ISearch): Observable<IHospitalLicense[]> {
    return this.http.post<IHospitalLicense[]>(this.api + 'SearchLicenses', search);
  }

  public getAssignedLicenses(): Observable<IHospitalLicense[]> {
    return this.http.get<IHospitalLicense[]>(this.api + 'GetAssignedLicenses');
  }

  public assignLicense(licenseId: number, staff: IStaff): Observable<boolean>{
    return this.http.post<boolean>(this.api + 'AssignLicense/' + licenseId, staff);
  }

  public createLicense(): Observable<IHospitalLicense> {
    return this.http.post<IHospitalLicense>(this.api + 'CreateLicense', null);
  }

  public updateLicense(license: IHospitalLicense): Observable<boolean>{
    return this.http.post<boolean>(this.api + 'UpdateLicense', license);
  }

  public archiveLicense(licenseId: number, archived: boolean): Observable<boolean>{
    return this.http.post<boolean>(this.api + 'ArchiveLicense/' + licenseId + '/' + archived, null);
  }

  public getStaff(licenseType: string): Observable<IStaff[]> {
    return this.http.get<IStaff[]>(this.api + 'GetStaff/' + licenseType);
  }

  public getLicenseRequests(ownerChange: boolean, includeAll: boolean): Observable<ILicenseRequest[]>{
      return this.http.get<ILicenseRequest[]>(this.api + 'GetLicenseRequests/' + ownerChange + '/' + includeAll);
  }

  public checkLicenseRequest(licenseId: string): Observable<string> {
    return this.http.get(this.api + 'CheckLicenseRequest/' + licenseId, { responseType: 'text' });
  }

  public approveLicenseRequest(licenseRequest: ILicenseRequest): Observable<boolean>{
    return this.http.post<boolean>(this.changeApi + 'ApproveLicenseRequest', licenseRequest);
  }

  public updateLicenseStatus(licenseId: number, statusId: number): Observable<IHospitalLicense>{
    return this.http.post<IHospitalLicense>(this.api + 'UpdateLicenseStatus/' + licenseId + '/' + statusId, null);
  }

  public uploadHospitalData(file: FormData, isSicf: boolean): Observable<boolean>{
      return this.http.post<boolean>(this.dataMigrationApi + 'ImportHospitalData/' + isSicf, file)
  }

  public deleteHospitalLicense(licenseId: number): Observable<boolean> {
    return this.http.delete<boolean>(this.api + 'DeleteHospitalLicense/' + licenseId);
  }

    // Representative Contacts
  public addRepresentativeContact(contact: IRepresentativeContact): Observable<IRepresentativeContact> {
    return this.http.post<IRepresentativeContact>(this.api + 'AddRepresentativeContact', contact);
  }

  public updateRepresentativeContact(contact: IRepresentativeContact): Observable<boolean> {
    return this.http.post<boolean>(this.api + 'UpdateRepresentativeContact', contact);
  }

  public deleteRepresentativeContact(contactId: number): Observable<boolean> {
    return this.http.delete<boolean>(this.api + 'DeleteRepresentativeContact/' + contactId);
  }

  public checkDuplicateChiefNurseName(chiefNurseName: string, licenseId: string): Observable<boolean> {
    return this.http.get<boolean>(this.api + 'CheckDuplicateChiefNurseName/' + chiefNurseName + '/' + licenseId);
  }
}
